var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { useForm } from 'ziphy-web-shared/basic/lib/forms';
import { Textarea } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import { $appts } from '@store';
const ApptFeedbackModal = ({ fullAppt, _core }) => {
    const { t } = useTranslation();
    const { appointment } = fullAppt;
    const [text, setText] = useState('');
    const { form } = useForm({
        feedback: { value: text, rules: ['required'] },
    });
    const { feedback } = form.fields;
    const handleSubmit = $loader.registerHandler('submit-feedback', (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (form.validateAll().isValid) {
            let res = yield $appts.sendFeedback(appointment.id, { feedback: feedback.value });
            if (res.isSuccess) {
                setText(feedback.value);
                _core.onHide();
            }
        }
    }));
    return (_jsxs(Modal, Object.assign({ centered: true, scrollable: true }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: _core.onHide }) })), _jsx(Modal.Header, { children: t('label.feedback') }), _jsxs(Modal.Body, { children: [_jsx("div", Object.assign({ className: "mb-30" }, { children: t('text.appt_feedback.message') })), _jsx("form", Object.assign({ id: "appt_feedback_modal", onSubmit: handleSubmit }, { children: _jsx(Textarea, { label: t('label.write_your_text_here'), rows: 7, field: feedback, placeholder: t('text.appt_feedback.placeholder'), mode: "lg", autoFocus: true, autoGrow: false }) }))] }), _jsx(Modal.Footer, { children: _jsx(Button, Object.assign({ mode: ['primary', 'block'], form: "appt_feedback_modal", isLoading: $loader.isRunHandler('submit-feedback') }, { children: t('btn.submit') })) })] })));
};
export default observer(ApptFeedbackModal);
